import {useRef, useState} from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useDisableDuplicateClick = <T extends (...args: any[]) => void>(
  fn: T,
  wait: number
) => {
  const isLocked = useRef(false);
  const [isLocking, setIsLocking] = useState(false);

  const wrappedFn = (...args: Parameters<T>) => {
    if (!isLocked.current) {
      // call the fn on the 1st click
      fn(...args);

      isLocked.current = true;
      setIsLocking(true);

      setTimeout(() => {
        isLocked.current = false;
        setIsLocking(false);
      }, wait);
    }
  };

  return {wrappedFn, isLocking};
};
